import { render } from "./Admin.vue?vue&type=template&id=0caae7e7&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=0caae7e7&scoped=true&lang=css"

import exportComponent from "../../../../../../../var/www/html/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0caae7e7"]])

export default __exports__